export const GTM_ID = 'GTM-W26Q53K'

const getDataLayer = () => {
  if (!window.dataLayer) {
    window.dataLayer = []
  }
  return window.dataLayer
}

export const gtmPurchase = (
  orderId: number,
  orderPrice: number,
  packageDesc: string,
  email: string,
  phone: string
) => {
  const dataLayer = getDataLayer()

  dataLayer.push({
    event: 'purchase',
    eventModel: {
      currency: 'TRY',
      email: email,
      items: packageDesc,
      phone: phone,
      transaction_id: orderId,
      value: orderPrice,
    },
  })
}

export const gtmView = (
  advisorName: string,
  advisorId: number,
  price: number
) => {
  const dataLayer = getDataLayer()

  dataLayer.push({
    event: 'viewitem',
    eventModel: {
      currency: 'TRY',
      items: [
        {
          affiliation: 'Google Merchandise Store',
          item_brand: 'Advicemy',
          item_category: 'Advisor',
          item_id: advisorId,
          item_name: advisorName,
          price: price + ',00',
          quantity: 1,
        },
      ],
      value: price + ',00',
    },
  })
}
